import { useEffect, useState } from "react";
import Header from "../components/header";
import { SignupModelHelper } from "../data/SignupModel";
import Typewriter from 'typewriter-effect';
import TagManager from "react-gtm-module";
import { dataLayerHelper } from "../data/dataLayerModel";

export default function PerguntasFim(props: any) {

    const [name, setName] = useState('');
    const [typed, setTyped] = useState(false);
    const [pageBack, setPageBack] = useState('');

    useEffect(() => {
        SignupModelHelper.checkLogin().then(async(userId) => {
            if ( !userId ) {
                document.location = '#/';
            }
        });
        
        TagManager.dataLayer(dataLayerHelper.pagina('tipo', 'perguntas-fim'));
    }, [])

    let optionItemsList: any = [
        { label: "Fechar", value: true },
    ];

    let optionItems = optionItemsList.map((c: any) => {

        return <div className="option-item mt-3" key={optionItemsList.indexOf(c)}>
            <button className={`btn btn-outline btn-full`} onClick={ () => {}}>{c.label}</button>
        </div>;
    });

    return (
        <>
            <Header step={1} total={1} title="Perguntas" previous={pageBack}></Header>

            <div className="chat-container">

                <div className="chat">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                                <div className="chat-item">
                                    <img src="./images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                                    <div className="chat-item-content">
                                        <Typewriter
                                            onInit={(typewriter) => {
                                                typewriter
                                                .changeDelay(15)
                                                .typeString(`<strong>Prontinho!</strong> <br/><br/>Agora a empresa já sabe um pouco mais sobre você. <br/><br/>Boa sorte!`)
                                                .callFunction(() => {
                                                    setTyped(true)
                                                })
                                                .start();
                                        }} />
                                    </div>
                                </div>

                                { typed &&
                                <div className="option-list">
                                    {
                                        optionItems.map((objItem: any) => {
                                            return objItem;
                                        })
                                    }
                                </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}
